<template>
  <transition name="slide-top">
    <div v-if="visible" class="top-tip" :class="[typeClass, customClass]" role="alert">
      <span class="top-tip__content">{{ message }}</span>
      <button v-if="showClose" class="top-tip__close" @click="close">×</button>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'TopTip',
  props: {
    message: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'success',
      validator: (val) => ['success', 'error', 'warning', 'info'].includes(val)
    },
    duration: {
      type: Number,
      default: 3000
    },
    showClose: {
      type: Boolean,
      default: false
    },
    customClass: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      visible: false,
      timer: null
    }
  },
  computed: {
    typeClass() {
      return `top-tip--${this.type}`
    }
  },
  methods: {
    open() {
      // 每次打开前，先清空旧定时器
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.visible = true

      // 重新开始计时
      if (this.duration > 0) {
        this.timer = setTimeout(() => {
          this.close()
        }, this.duration)
      }
    },
    close() {
      this.visible = false
      // 关闭时清空定时器
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.$emit('close')
    },
    resetTimer() {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      if (this.visible && this.duration > 0) {
        this.timer = setTimeout(() => {
          this.close()
        }, this.duration)
      }
    }
  },
  beforeDestroy() {
    if (this.timer) clearTimeout(this.timer)
  }
}
</script>

<style scoped>
/* 基础样式 */
.top-tip {
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  min-width: 300px;
  max-width: 80%;
  padding: 12px 24px;
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  font-size: 14px;
  line-height: 1.5;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  z-index: 9999;
  box-sizing: border-box;
  pointer-events: auto;
  border-left: 4px solid transparent;
}

/* 不同类型样式 */
.top-tip--info {
  background-color: #edf2f7;
  border-left-color: #3182ce;
  color: #2c3e50;
}
.top-tip--success {
  background-color: #e6fffa;
  border-left-color: #38a169;
  color: #276749;
}
.top-tip--error {
  background-color: #fff5f5;
  border-left-color: #e53e3e;
  color: #c53030;
}
.top-tip--warning {
  background-color: #fffaf0;
  border-left-color: #ed8936;
  color: #c05621;
}

/* 内容区域 */
.top-tip__content {
  flex: 1;
  word-break: break-word;
}

/* 关闭按钮 */
.top-tip__close {
  background: none;
  border: none;
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
  padding: 0;
  margin: 0;
  color: inherit;
  opacity: 0.6;
  transition: opacity 0.2s;
}
.top-tip__close:hover {
  opacity: 1;
}

/* 滑入动画 */
.slide-top-enter-active,
.slide-top-leave-active {
  transition: all 0.3s ease;
}
.slide-top-enter,
.slide-top-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(-100%);
}
</style>